import React, { Fragment, useState } from 'react'
import ParticularListView from '../../../components/account/setup/particular/ParticularListView'
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';

const AcParticularCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.AccountURL + 'account/particular/create/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
    const [onID, setOnID] = useState<number | null>(null);
  return (
    <Fragment>
        <ParticularListView setOnURL={setOnURL} handleFormSuccess={handleFormSuccess} results={data} loading={loading} error={error} />
    </Fragment>
  )
}

export default AcParticularCreateListView